import React from 'react'
import { Icon } from 'antd'

import { Button, Col, ColumnProps, Form, FormInput, FormResetButton, Row } from '@digital/ui';

interface IProps {
    nameInputForm: string;
    placeholder: string;
    setSelectedKeys: ((selectedKeys: string[]) => void) | undefined;
    selectedKeys: string[] | undefined;
    confirm: (() => void) | undefined;
    clearFilters: ((selectedKeys: string[]) => void) | undefined;
}

export const FormFilterDropDown = ({ nameInputForm, placeholder, setSelectedKeys, selectedKeys, confirm, clearFilters }: IProps) => {
    return (
        <Form>
            <Row>
                <FormInput
                    placeholder={placeholder}
                    name={nameInputForm}
                    style={{ marginTop: '15px' }}
                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                    onPressEnter={() => {
                        if (typeof confirm === 'function') confirm();
                    }}
                />
            </Row>
            <Row>
                <Col span={6}>
                    <Button
                        type="primary"
                        style={{ marginLeft: '5px' }}
                        onClick={() => {
                            if (typeof confirm === 'function') confirm();
                        }}
                        icon="commons-search"
                        size="small">
                        Pesquisar
                    </Button>
                </Col>
                <Col span={6}>
                    <FormResetButton
                        size="small"
                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                        beforeReset={() => {
                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                        }}>
                        Limpar
                    </FormResetButton>
                </Col>
            </Row>
        </Form>
    )
}

export const mountFormFilterDropDown = (nameColum: string, placeholder: string): ColumnProps<any> => {
    return {
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => FormFilterDropDown({
            nameInputForm: nameColum,
            placeholder,
            selectedKeys,
            setSelectedKeys,
            confirm,
            clearFilters,
        }),
        filterIcon: (filtered: any) => {
            const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
            return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
            try {
                if (record != undefined
                    && record.hasOwnProperty(nameColum)
                    && record[nameColum] != null) {
                    return record[nameColum]
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase())
                }
            } catch (e) {
            }
            return false;
        }
    };
}